// extracted by mini-css-extract-plugin
module.exports = {"hover-wrapper":"_2MqUD","hoverWrapper":"_2MqUD"};